/** Formats a Brazilian phone number as (DD) XXXXX-XXXX or (DD) XXXX-XXXX. */
export function maskPhoneInput(value: string): string {
  const digits = value.replace(/\D/g, "").slice(0, 11);

  if (digits.length <= 10) {
    const part1 = digits.slice(0, 2);
    const part2 = digits.slice(2, 6);
    const part3 = digits.slice(6, 10);
    return [part1 && `(${part1}`, part1 && part1.length === 2 ? ") " : "", part2, part3 && `-${part3}`]
      .join("")
      .trim();
  }

  const part1 = digits.slice(0, 2);
  const part2 = digits.slice(2, 7);
  const part3 = digits.slice(7, 11);
  return [part1 && `(${part1}`, part1 && part1.length === 2 ? ") " : "", part2, part3 && `-${part3}`]
    .join("")
    .trim();
}
